export const BUTTON_LABELS = {
    "GENERATE_LINK": "Auto-generate new link",
    "ADD_CUSTOM_LINK": "Customize new link",
    "PRIVATE_LINKS_TABLE": "Secure URLs",
    "PRIVATE_FORM": "New Secure URL",
    "PROTECT_FILE": "Protect this file",
    "UN_PROTECT_THIS_FILE": "Unprotect this file",
    "SYNC_TO_S3": "Sync to S3",
    "UN_SYNC_TO_S3": "Unsync from S3"
}

export const MESSAGES = {
    "CREATE_NEW_PRIVATE_LINK" : "Great! You’ve successfully created a new secure link.",
    "CHANGE_LINK_STATUS": "Fantastic! You've successfully changed the link status.",
    "DELETE_PRIVATE_LINK": "Cool! You’ve successfully deleted the link",
    "COPY_LINK_TO_CLIPBOARD": "Great! You’ve successfully copied the link to clipboard.",
    "COPY_PROTECTED_LINK_TO_CLIPBOARD": "Great! You’ve successfully copied the protected link to clipboard.",
    "CONFIRM_DELETE_LINK": "Are you sure to delete this link?",
    "FILE_TO_CONFIG": "You're protecting ",
    "UPDATE_LINK_DATA": "Cool! You’ve successfully updated the link data.",
    "PROTECT_FILE": "Great! You've successfully protected this file.",
    "UN_PROTECT_FILE": "Great! You've successfully unprotected this file.",
    "SET_DEFAULT_PRIVATE_LINK" : "Cool! You've successfully set default private link",
    "ERR_CREATE_NEW_PRIVATE_LINK": "Opps! Unable to create new link. Please try again or contact plugin owner.",
    "ERR_DELETE_PRIVATE_LINK": "Opps! Unable to delete new link. Please try again or contact plugin owner.",
    "ERR_UPDATE_PRIVATE_LINK": "Opps! Unable to update the link. Please try again or contact plugin owner.",
    "UPDATE_IP_BLOCK_OK": "Great! You've successfully blocked those IP addresses.",
    "UPDATE_PERMISSION_OK": "Great! Your file access permission is updated.",
    "ERR_CALL_DATA": "Opps! There is something's wrong with plugin API. Please try again or contact plugin owner.",
    "ERR_MEMBERSHIPS_NON": "Please select at least one membership option!"
}

export const TABS = {
    TABLE: 0,
    FORM: 1,
    FILE_ACCESS_PERMISSION: 2
}
